<template>
  <div class="solution_sheet__item__subitem" :class="classNames">
    <div class="solution_sheet__item__subitem__content">
      <p class="solution_sheet__item__subitem__title t-label t-label--small">
        {{ title }}
      </p>

      <div class="solution_sheet__item__subitem__body">
        <slot />
      </div>
    </div>

    <div
      class="solution_sheet__item__subitem__illustration"
      v-if="$slots.illustration"
    >
      <slot name="illustration" />
    </div>
  </div>
</template>

<script>
import { CalcIllustration } from "@/components";

export default {
  components: {
    CalcIllustration,
  },

  props: {
    title: {
      required: true,
      default: "Título por definir",
      type: String,
    },
  },

  computed: {
    classNames() {
      return [
        this.$slots.illustration
          ? "solution_sheet__item__subitem--has_illustration"
          : "",
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.solution_sheet__item__subitem {
  $root: &;

  position: relative;
  margin-bottom: 1em;

  &--has_illustration {
    display: flex;
    align-items: flex-end;

    #{$root}__content {
      flex-grow: 1;
    }
  }

  &__title {
    margin-top: $base-unit * 2;
    margin-bottom: $base-unit * (3/8);
  }
}
</style>